import { useQuery } from '@tanstack/react-query';

import { fetchPpaViewList, getPpaViewListQueryKey } from 'hooks/ppa/usePpaViews';
import { getAuthUserMail } from 'utils/helperMethods';

type UseFetchViewListParams = {
    scenarioId?: number | null;
    enabled?: boolean;
    /** When true, never serve cached view list (used on scenario tab switches). */
    alwaysFresh?: boolean;
};

const VIEW_LIST_STALE_TIME_MS = 1000 * 60 * 10;

export function useFetchViewList({
    scenarioId,
    enabled = true,
    alwaysFresh = false,
}: UseFetchViewListParams = {}) {
    const userId = getAuthUserMail() || null;

    return useQuery({
        queryKey: getPpaViewListQueryKey(scenarioId, userId),
        queryFn: () => fetchPpaViewList(scenarioId),
        enabled,
        staleTime: alwaysFresh ? 0 : VIEW_LIST_STALE_TIME_MS,
        gcTime: alwaysFresh ? 0 : undefined,
        refetchOnMount: alwaysFresh ? 'always' : true,
    });
}

export default useFetchViewList;
